import { Sort, SortDirection } from "@angular/material/sort";
import { ColumnData } from "./common-table-interface";

export default function multiSort(data: any[], sort: Sort, columns: ColumnData[]) {
  //debugger;
  const primarySortKey = sort.active;
  const isAsc1 = sort.direction === 'asc';
  const sortColumn = columns.find((column) => {
    return column.columnDef === primarySortKey
  });
  const subSortKey = sortColumn?.subSortKey;
  const isAsc2 = sortColumn?.subSortDirection === 'asc';

  data = data?.sort((a: any, b: any) => {
    if(!subSortKey) {
      return compare(a[primarySortKey], b[primarySortKey], isAsc1);
    }
    if(subSortKey) {
      if (a[primarySortKey] instanceof Date){
        console.debug("compare dates")
        if (a[primarySortKey].getTime() === b[primarySortKey].getTime()) {
          return compare(a[subSortKey], b[subSortKey], isAsc2);
        } else {
          return compare(a[primarySortKey], b[primarySortKey], isAsc1);
        }
      }else{
        if (a[primarySortKey] === b[primarySortKey]) {
          return compare(a[subSortKey], b[subSortKey], isAsc2);
        } else {
          return compare(a[primarySortKey], b[primarySortKey], isAsc1);
        }
      }
      
    }
    return 0;
  });

  return data;
}

function compare(a: number | string | Date, b: number | string | Date, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
